module.exports = __webpack_public_path__ + "static/media/Salvation-Church-in-Crisis.22bb55bb.jpg";